/**
 * DFE API
 *
 * Endpoints:
 *   GET  /jobs/dfe/:jobId
 *   POST /jobs/dfe/:jobId
 *   GET  /jobs/dfe-materials
 */

import { apiClient } from '@/lib/api';
import type {
  CreateDfeBody,
  DfeMaterialsResponse,
  DfeResponse,
  DfeSubmission,
} from '@skewb-works/contracts';

export type { DfeResponse, DfeSubmission, DfeMaterialsResponse };

export async function getDfe(jobId: number): Promise<DfeResponse> {
  return apiClient.get<DfeResponse>(`/jobs/dfe/${jobId}`);
}

export async function createDfe(jobId: number, body: CreateDfeBody): Promise<DfeSubmission> {
  return apiClient.post<DfeSubmission>(`/jobs/dfe/${jobId}`, body);
}

export async function getDfeMaterials(): Promise<DfeMaterialsResponse> {
  return apiClient.get<DfeMaterialsResponse>('/jobs/dfe-materials');
}
